"use client"

import React from "react"
import { useAuth0 } from "@auth0/auth0-react"
import Chat from "../Chat"
import GroupForums from "../Groups/GroupForums"
import GlobeWithPins from "../GlobeWithPins"
import MissionCarousel from "../MissionCarousel"
import FriendsModal from "./FriendsModal"
import crownLogo from "../../resources/CrownCracked.png"
import FishersOfMen from "../../resources/Fisherman.jpg"
import "../../styles/components/CommunityForum.css"

export default function CommunityForum({ isDarkMode }) {
  const { isAuthenticated, loginWithRedirect } = useAuth0()

  return (
    <div className="community-forum-page">
      <div className="community-forum-hero" style={{ backgroundImage: `url(${FishersOfMen})` }}>
        <div className="community-forum-overlay" />
        <div className="community-forum-hero-content">
          <div className="community-forum-brand">
            <img src={crownLogo} alt="Thousand Year Kingdom crown" className="community-forum-logo" />
            <div>
              <p className="community-forum-eyebrow">Community</p>
              <h1 className="community-forum-title">Forum</h1>
              <p className="community-forum-subtitle">
                Share wisdom, ask questions, and collaborate with the entire Kingdom—threads are open to every member.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="community-forum-shell">
        {isAuthenticated ? (
          <>
            <FriendsModal />
            <GroupForums forumTitle="Community Forum" isGlobalForum groupId={0} />
            <Chat isDarkMode={isDarkMode} />
          </>
        ) : (
          <section className="community-forum-public-preview" aria-label="Community forum preview">
            <p className="community-extra-eyebrow">Members only</p>
            <h2 className="community-extra-title">Forum discussions open after sign in</h2>
            <p className="community-extra-subtitle">
              The public page explains the mission. Member conversations, replies, friends, and notifications stay
              inside the authenticated community space.
            </p>
            <button
              type="button"
              className="community-forum-public-button"
              onClick={() => loginWithRedirect()}
            >
              Sign in to open the forum
            </button>
          </section>
        )}

        <div className="community-forum-extras">
          <div className="community-extras-grid">
            <section className="community-extra-card mission">
              <div className="community-extra-header">
                <p className="community-extra-eyebrow">Our mission</p>
                <h2 className="community-extra-title">What we&apos;re building</h2>
                <p className="community-extra-subtitle">
                  Explore the pillars of the Kingdom while you participate in the forums.
                </p>
              </div>
              <MissionCarousel headingCentered />
            </section>

            <section className="community-extra-card globe">
              <div className="community-extra-header">
                <p className="community-extra-eyebrow">Global needs</p>
                <h2 className="community-extra-title">See the world we&apos;re serving</h2>
                <p className="community-extra-subtitle">
                  Pinpoint conflicts, trafficking hotspots, food insecurity, and environmental stress in real time.
                </p>
              </div>
              <GlobeWithPins darkMode heightClass="h-[420px] md:h-[620px]" />
            </section>
          </div>
        </div>
      </div>
    </div>
  )
}
